import type { IconSvgObject } from './types';

const Navigation02Icon: IconSvgObject = [
  ["path", { d: "M13.9998 11.9999C13.9998 13.1045 13.1044 13.9999 11.9998 13.9999C10.8952 13.9999 9.99982 13.1045 9.99982 11.9999C9.99982 10.8954 10.8952 9.99994 11.9998 9.99994C13.1044 9.99994 13.9998 10.8954 13.9998 11.9999Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 7L12 2L15 7H9Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9 17L12 22L15 17H9Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M2 12L7 9V15L2 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M22 12L17 9V15L22 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default Navigation02Icon;
